import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

const MinimalLayout = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh"
      width="100%"
    >
      <Outlet />
    </Box>
  );
};

export default MinimalLayout;
